import { Module } from "../../../../ui/components/Module";
import Loading from "./Loading";

export const SuspenseFallback = () => {
  return (
    <>
      <Module>
        <></>
      </Module>
      <Loading/>
    </>
  );
};
